@let activeTasks = (_trainingLogResponse$ | async)?.data;

<div class="header">
  <h3 class="card__title" i18n="@@d4_list_widget.card.header.title">My D4 Tasks</h3>
  <p-button
    pTooltip="Actions"
    i18n-pTooltip="@@common.button.actions"
    tooltipPosition="bottom"
    icon="pi pi-ellipsis-v"
    [rounded]="true"
    [text]="true"
    size="small"
    (click)="actionMenu.toggle($event)" />
</div>

<div #responsiveWidgetTable>
  @if (!isEditing) {
    @if (!activeTasks || activeTasks.length === 0) {
      <div class="empty-placeholder">
        <p i18n="@@d4_list_widget.card.empty_placeholder">No D4 tasks to display</p>
      </div>
    } @else {
      <p-table [value]="activeTasks" stripedRows>
        <ng-template pTemplate="header">
          <tr carehub-table-header [config]="getVisibleHeaderConfig()"></tr>
        </ng-template>
        <ng-template pTemplate="body" let-task>
          <tr class="row">
            <td [ngClass]="{ 'row__column--hidden': !isColumnVisible(1) }">
              {{ task.documentTitle }}
            </td>
            <td class="date" [ngClass]="{ 'row__column--hidden': !isColumnVisible(2) }">
              {{ task.sendDate | date: 'dd/MM/yyyy' }}
            </td>
            <td
              class="date"
              [ngClass]="{
                'date--expired': isDateExpired(task.dueDate),
                'date--expire-soon': isDateCloseToExpire(task.dueDate),
                'row__column--hidden': !isColumnVisible(1),
              }">
              {{ task.dueDate | date: 'dd/MM/yyyy' }}
            </td>
            <td class="row__actions">
              <a target="_blank" href="{{ getDocumentUrl(task.documentId) }}">
                <p-button
                  pTooltip="Open task"
                  tooltipPosition="bottom"
                  icon="pi pi-external-link"
                  iconPos="right"
                  [rounded]="true"
                  [text]="true"
                  size="small" />
              </a>
            </td>
          </tr>
        </ng-template>
      </p-table>
      @let trainingLogResponse = _trainingLogResponse$ | async;
      <p-paginator
        (onPageChange)="onPageChange($event)"
        [first]="0"
        [rows]="trainingLogResponse?.pageSize"
        [totalRecords]="trainingLogResponse?.totalCount" />
    }
  } @else {
    <div class="edit-container">
      <carehub-d4-active-tasks-list-configuration
        [initialConfiguration]="configuration"
        #configurationComponent>
      </carehub-d4-active-tasks-list-configuration>
      <div class="edit-container__actions">
        <p-button
          class="edit-container__actions--end"
          label="Cancel"
          severity="secondary"
          (onClick)="onConfigurationCancel()">
        </p-button>
        <p-button
          class="edit-container__actions--end"
          label="Update"
          (onClick)="onConfigurationUpdate()"
          [disabled]="!isConfigurationValid()">
        </p-button>
      </div>
    </div>
  }
</div>

<p-menu #actionMenu [model]="actionMenuItems" [popup]="true" appendTo="body"> </p-menu>
